import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist({
  key: "recoil-persist", // this key is used for localStorage
  storage: localStorage,
});

const themeAtom = atom({
  key: "theme",
  default: {
    mode: "light",
    dir: "ltr",
  },
  effects_UNSTABLE: [persistAtom],
});

export default themeAtom;
